<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		:class="class"
	>
		<path
			d="M8.00065 3.33203V12.6654M3.33398 7.9987H12.6673"
			stroke="currentColor"
			stroke-width="2"
			stroke-linecap="square"
		/>
	</svg>
</template>
